<template>
	
	<div class="testbg">

		<div style="text-align: right;">
			<div class="block">
				<span class="demonstration"></span>

				<el-date-picker
				v-model="month"
				type="month"
				value-format="yyyy-MM"
				@change="fetchData"
				placeholder="选择月">
				</el-date-picker>
			</div>
		</div>

		<!-- <el-row class="mt-3" :gutter="20">
			<el-col :xs="24" :span="12">
				<el-card class="box-card h_100 new_card "  shadow="hover">
					<div slot="header" class="clearfix">
						<span>{{$t('indexInfo.monthData')}}</span>
					</div>
									
					<div ref="myChart1" style="height: 300px;"></div>
							
				</el-card>
			</el-col>
			<el-col :xs="24" :span="12">
				<el-card class="box-card h_100 new_card "  shadow="hover">
					<div slot="header" class="clearfix">
						<span>{{$t('indexInfo.monthData')}}</span>
					</div>
									
					<div ref="myChart2" style="height: 300px;"></div>	
				</el-card>
			</el-col>
			
		</el-row>
		
		<el-row class="mt-3" :gutter="20">
			<el-col :xs="24" :span="12">
				<el-card class="box-card h_100 new_card "  shadow="hover">
					<div slot="header" class="clearfix">
						<span>{{$t('indexInfo.monthDataTotal')}}</span>
					</div>
									
					<div ref="myChart3" style="height: 300px;"></div>
							
				</el-card>
			</el-col>
			<el-col :xs="24" :span="12">
				<el-card class="box-card h_100 new_card "  shadow="hover">
					<div slot="header" class="clearfix">
						<span>{{$t('indexInfo.monthDataOrder')}}</span>
					</div>
									
					<div ref="myChart4" style="height: 300px;"></div>	
				</el-card>
			</el-col>
			
		</el-row> -->
	
		<el-row class="mt-3" :gutter="20">
			<el-col :xs="24" :span="24">
				<el-card class="box-card h_100 new_card "  shadow="hover">
					<div slot="header" class="clearfix">
						<span>{{$t('indexInfo.userInfo')}}</span>
					</div>
							
					<div  style="width: 100%;">
						<el-row style="height: 70px;" :gutter="20">
							<el-col :span="12" :xs="24">
								<div class="new_head_nav" >
									<div class="new_head_nav_icon">
										<img :src="userInfo.head" style="width: 100%;" alt="">
									</div>
									<div class="ml-3 new_head_right">
										<div class="grid-content ">{{userInfo.name}}</div>
										<div class="grid-content ">{{userInfo.username}}</div>
									</div>
								</div>
							</el-col>
							<!-- <el-col :span="8" :xs="24">
								<div class="grid-content">{{$t('indexInfo.quota')}}</div>
								<div class="grid-content text_chengse">{{userInfo.quota}}</div>
							</el-col> -->
							<el-col :span="12" :xs="24">
								<div class="grid-content">{{$t('indexInfo.money')}}</div>
								<div class="grid-content text_chengse">
								{{userInfo.money}}
								
								<el-button class="ml-3" type="success" size="small"  @click="openModelZ(false)"  >{{$t('upay.btn1')}}</el-button>
								</div>
							</el-col>
							<!-- <el-col :span="3" :xs="24">
								<el-button size="mini" plain type="primary" v-auth="'editAdmin'" >{{$t('layout.pay')}}</el-button>
							</el-col> -->
						</el-row>
					</div>
							
				</el-card>
			</el-col>
			<!-- <el-col :xs="24" :span="12">
				<el-card class="box-card h_100 new_card "  shadow="hover">
					<div slot="header" class="clearfix">
						<span>{{$t('indexInfo.useStr')}}</span>
					</div>
							
					<div  style="width: 100%;">
						<el-row style="height: 70px;" :gutter="20">
							<el-col :span="8" :xs="24">
								<div style="display: flex;align-items: center;">
											<div>
												<div class="mb-2"><i class="iconfont icon-dailishang mr-2"></i>{{$t('indexInfo.useTotal')}}</div>
												<div class="text_chengse">{{total_list.total_money}}</div>
											</div>
											
										</div>
							</el-col>
							<el-col :span="8" :xs="24">
								<div style="display: flex;align-items: center;">
											<div>
												<div class="mb-2"><i class="iconfont icon-dailishang mr-2"></i>{{$t('home.mon')}}</div>
											<div class="text_chengse">{{total_list.mon_money}}</div>
											</div>
											
										</div>
							</el-col>
							<el-col :span="8" :xs="24">
								<div style="display: flex;align-items: center;">
											<div>
												<div  class="mb-2"><i class="iconfont icon-kehuliebiao1 mr-2"></i>{{$t('home.zuo')}}</div>
												<div class="text_chengse">{{total_list.zuo_money}}</div>
											</div>
											
										</div>
							</el-col>
						</el-row>
					</div>
							
				</el-card>
			</el-col> -->
			
		</el-row>

		<el-row class="mt-3" :gutter="20">
			<el-col :xs="24" :span="12">
				<el-card class="box-card h_100 new_card "  shadow="hover">
					<div slot="header" class="clearfix">
						<span>{{$t('indexInfo.monthData')}}</span>
					</div>
									
					<div ref="myChart1" style="height: 300px;"></div>
							
				</el-card>
			</el-col>
			<el-col :xs="24" :span="12">
				<el-card class="box-card h_100 new_card "  shadow="hover">
					<div slot="header" class="clearfix">
						<span>{{$t('indexInfo.monthData')}}</span>
					</div>
									
					<div ref="myChart2" style="height: 300px;"></div>	
				</el-card>
			</el-col>
			
		</el-row>
		
		<el-row class="mt-3" :gutter="20">
			<el-col :xs="24" :span="12">
				<el-card class="box-card h_100 new_card "  shadow="hover">
					<div slot="header" class="clearfix">
						<span>{{$t('indexInfo.monthDataTotal')}}</span>
					</div>
									
					<div ref="myChart3" style="height: 300px;"></div>
							
				</el-card>
			</el-col>
			<el-col :xs="24" :span="12">
				<el-card class="box-card h_100 new_card "  shadow="hover">
					<div slot="header" class="clearfix">
						<span>{{$t('indexInfo.monthDataOrder')}}</span>
					</div>
									
					<div ref="myChart4" style="height: 300px;"></div>	
				</el-card>
			</el-col>
			
		</el-row>


		<!-- <div class="home_all mt-3" :class="this.layout.is_phone?'home_all_phone':''">
				
			<el-row :gutter="layout.index_p.gutter" class="h_1 mb-3" >
					
					<el-col  :span="24" class=" h_100" >
						<el-card class="box-card h_100 new_card "  shadow="hover">
								<div slot="header" class="clearfix">
									<span>{{$t('indexInfo.yearData')}}</span>
								</div>
								
									
								<div ref="myChart" style="height: 300px;">
									
								</div>
									
							</el-card>
							
						</el-col>
			</el-row>  -->
			
			<el-row :gutter="layout.index_p.gutter" class="h_1"  style="margin-top: 10px;">
			
					<el-col  :span="24" class="pb-4 h_100" >
						<el-card class="box-card h_100 new_card "  shadow="hover">
								<div slot="header" class="clearfix">
									<span>{{$t('indexInfo.loginLog')}}</span>
								</div>
								<el-table
								   	height="330"
								    :data="tableData" 
								    style="width: 100%;">
									<el-table-column align="center" type="index" :label="$t('indexInfo.sort')" >
									  </el-table-column>
								      <el-table-column align="center" 
								        prop="create_time"
										:label="$t('indexInfo.create_time')"
								        >
								      </el-table-column>
								      <el-table-column
								        prop="browse" align="center" 
								        :label="$t('indexInfo.browse')"
								        >
								      </el-table-column>
									  
									  <el-table-column
									    prop="ip" align="center"
										:label="$t('indexInfo.ip')">
										</el-table-column>
									  <el-table-column
									    prop="sysversion" align="center"
									    :label="$t('indexInfo.sysversion')">
									  </el-table-column>
								
								    </el-table>
									
									<div class="mt-2" style="overflow-x: auto;">
										<el-pagination
										:current-page="page.current" :page-sizes="page.sizes" :page-size="page.size" @size-change="handleSizeChange"
										 @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
										</el-pagination>
									</div>
									
							</el-card>
							
						</el-col>
					
					
					
			</el-row>
			
			
			<RechargeDialog :is_phone="layout.is_phone" :check_id="check_id" :recModel="zModel" @hide="zModel = false"  @successSub="successSub" @changeStatus="changeStatus"></RechargeDialog>
			
			
					
			<div v-if="this.layout.is_phone">.</div>
			<div style="width: 100%;height: 80px;"></div>
		</div>
	
		
		
		
		
	
		


		
		
			
			

	

	</div>
	
</template>

<script>
	//图形统计导入
	import common from '@/common/mixins/common.js';
	import RechargeDialog from '@/components/common/RechargeDialog.vue'
	import echarts from 'echarts'
	import { mapState } from 'vuex';
	export default {
		inject: ['layout', 'app'],
		mixins: [common],
		components: {
			
			RechargeDialog
			
		},
		data() {
			return {
				money:0,
				zModel:false,
				check_id:0,
				month:'',
				preUrl: "user/homeData", //列表地址

				userInfo: {},

				tableData: [],
				year_data: [],
				total_list: [],
				day_list: [],
				day_data: [],
				// month: [],
				shoplist: {},
				orderlist: {},
				counts: [],
				head_list:[],
				mtCheck:0,
				mtMoney:'',
				
			
				createModel:false,
				edit_title:'',
				addUrl: "user/editTxUrl", //修改提现地址
				form:{
					url:'',
					type:0
				},
				search:{
					date:''
				},
				
				rules: {
					url: [{
							required: true,
							message: "請輸入提现地址",
							trigger: 'blur',
						},
					
					]
				},
				
				order_list:[],
				sq_info:{
					'tk':{
						'status':0,
						'time':'',
						'url':''
					},
					'se':{
						'status':0,
						'time':'',
						'url':''
					},
					'la':{
						'status':0,
						'time':'',
						'url':''
					}
				}
			
			}
		},
		filters: {
			getCol(total) {
				return `col-${12/total}`
			}
		},
		watch: {
			refreshTrigger(newVal) {
				console.log('刷新触发，當前值:', newVal);
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			},
		},
		computed: {
			...mapState(['refreshTrigger']), // 监听 Vuex state
		},
		//dom渲染完毕 
		mounted() {
			//画统计图
			//this.drawLine()
			localStorage.setItem('commonDetailPage', '');
		},
		methods: {
			async fetchData() {
				if (!this.month) return;
				try {
					this.search.date = this.month 
					this.getList()
				} catch (error) {
					console.error('查询接口出错:', error);
				}
			},
			
			
			changeStatus(id,status){
				if(status=='paid'){
					this.commonList('selfMoney');
				}
			},
			
			commonList(type,id=0) {
				this.layout.loading = true;
				this.axios.post('/admin/user/commonList', {
					type: [type],
					id:id
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					
					if(type=='selfMoney'){
						this.money = list.money
					}
			
					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
			
			successSub(id){
				if(id!=0){
					this.getList()
					this.check_id = id
				}
				
			},
			
			// 打开模态框
			openModelZ(e = false) {
				// 增加
				if (!e) {
					// 初始化表單
					this.check_id = 0
				} else {
					// 修改
					
					this.check_id = e.id
				}
				
				// 打开dialog
				this.zModel = true
			},
			updateHomeTime(){
				this.page.current = 1
				this.getList()
			},
		submit(type) {
				this.$refs.form.validate(res => {
					if (res) {
						this.addOrEdit(this.form)
						
					}
				})
				
				
			},
			getListResult(e) {
				this.page.total = e.total
				this.userInfo = e.userInfo
				this.tableData = e.log_list
				this.total_list = e.total_list
				this.year_data = e.year_data
				this.day_data = e.day_data
				this.day_list = e.day_list
				this.month_total = e.month_total
				this.month_total_cloud = e.month_total_cloud
				this.month_order = e.month_order
				this.month_order_cloud = e.month_order_cloud
				this.month_l = e.month_l
				this.month = e.month


				if(this.page.current==1){
					this.order_list = e.order_list
					this.sq_info = e.sq_info
					this.head_list = e.head_list
					
				}
				
				
				// this.drawLine()
				this.drawLine1()
				this.drawLine2()
				this.drawLine3()
				this.drawLine4()
			},
		
			
			
			
			
			
			// drawLine() {
			//   const rawData = this.year_data.data;
			
			//   const colors = this.year_data.color; // 5种颜色
			
			//   const grid = {
			//     left: 50,
			//     right: 50,
			//     top: 50,
			//     bottom: 20
			//   };
			
			//   const series = this.year_data.name.map((name, sid) => {
			//     return {
			//       name,
			//       type: "bar",
			//       stack: "total",
			//       barWidth: "60%",
			//       label: {
			//         show: false, // ❌ 柱子上不显示数值
			//       },
			//       itemStyle: {
			//         color: colors[sid], // 🎨 自定义柱子颜色
			//       },
			//       data: rawData[sid], // 直接使用原始数据
			//     };
			//   });
			
			//   // 计算 tooltip 百分比
			//   const tooltipFormatter = (params) => {
			//     let total = 0;
			//     params.forEach((item) => {
			//       total += item.value;
			//     });
			//     return params
			//       .map(
			//         (item) =>
			//           `${item.marker} ${item.seriesName}: ${item.value} (${(
			//             (item.value / total) *
			//             100
			//           ).toFixed(2)}%)`
			//       )
			//       .join("<br/>");
			//   };
			
			//   // 初始化 ECharts 实例
			//   let myChart = echarts.init(this.$refs.myChart);
			
			//   // 设置配置项
			//   myChart.setOption({
			//     tooltip: {
			//       trigger: "axis",
			//       formatter: tooltipFormatter, // ✅ 鼠标悬停时显示数值 + 百分比
			//     },
				
			// 	toolbox: {
			// 	  feature: {
			// 	    dataView: { show: true, readOnly: false ,title:this.$t('tool.data')},
			// 	    magicType: { show: true, type: ["line", "bar"],title:{
			// 			line:this.$t('tool.line'),
			// 			bar:this.$t('tool.bar')
			// 		} },
			// 	    restore: { show: true ,title:this.$t('tool.restore')},
			// 	    saveAsImage: { show: true,title:this.$t('tool.down_img') }
			// 	  }
			// 	},
			//     legend: {
			//       selectedMode: true,
			//     },
			//     grid,
			//     yAxis: {
			//       type: "value",
			//     },
			//     xAxis: {
			//       type: "category",
			//       data: this.year_data.year,
			//     },
			//     series,
			//   });
			// },

			//折线图
			drawLine1() {
				
				let myChart1 = echarts.init(this.$refs.myChart1);
				var option;
				
				option = {
					xAxis: {
						type: 'category',
						boundaryGap: false,
						data: this.day_list,
						splitLine: {
							show: true, // 开启 y 轴横线
							lineStyle: {
								color: '#eee', // 可自定义颜色
								type: 'dashed' // 可选：'solid', 'dashed', 'dotted'
							}
						}
					},
					yAxis: {
						type: 'value',
						splitLine: {
							show: true, // 开启 y 轴横线
							lineStyle: {
								color: '#eee', // 可自定义颜色
								type: 'dashed' // 可选：'solid', 'dashed', 'dotted'
							}
						}
					},
					toolbox: {
						feature: {
							dataView: { show: true, readOnly: false ,title:this.$t('tool.data')},
							magicType: { show: true, type: ["line", "bar"],title:{
								line:this.$t('tool.line'),
								bar:this.$t('tool.bar')
							} },
							restore: { show: true ,title:this.$t('tool.restore')},
							saveAsImage: { show: true,title:this.$t('tool.down_img') }
						}
					},
					series: [
						{
							data: this.day_data,
							type: 'line',
							smooth: true,
							lineStyle: {
								color: '#00c2b3', // 设置线条颜色
								width: 2
							},
							itemStyle: {
								color: '#00c2b3' // 拐点颜色也统一
							}
						}
					]
				};

				option && myChart1.setOption(option);
				
			},

			//饼状图
			drawLine2() {
				let myChart2 = echarts.init(this.$refs.myChart2);

				// 多色配色方案（协调且风格统一）
				const colors = [
					'#00c2b3', // 蓝绿色（主色）
					'#36a3f7', // 清新蓝
					'#ffb64d', // 明亮橙黄
					'#f2637b', // 西瓜红
					'#91cc75', // 柔和绿
					'#fa8c16', // 活力橙
					'#ab6cf4', // 紫罗兰
					'#3ba272', // 青绿色
					'#fadb14', // 柠檬黄
					'#ff6f00'  // 深橘色
				];

				var option = {
					color: colors, // 设置饼图颜色顺序
					tooltip: {
						formatter: '{c}: {d}%'  // 提示框显示：数值 + 百分比
					},
					legend: {
						top: '1%',
						left: 'center'
					},
					toolbox: {
						feature: {
							saveAsImage: { show: true,title:this.$t('tool.down_img') }
						}
					},
					series: [
						{
							name: 'Access From',
							type: 'pie',
							radius: ['40%', '70%'],
							startAngle: 360,
							endAngle: 360,
							label: {
								show: true,
								formatter: '{c} ({d}%)' // 图上显示：数值 + 百分比
							},
							data: this.month_l // 结构应为 [{ value: xxx, name: xxx }, ...]
						}
					]
				};

				myChart2.setOption(option);
			},



			//柱状图1
			drawLine3() {
				let myChart3 = echarts.init(this.$refs.myChart3);
				var option;

				option = {
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow'
						}
					},
					grid: {
						left: '3%',
						right: '4%',
						bottom: '3%',
						containLabel: true
					},
					toolbox: {
						feature: {
							dataView: { show: true, readOnly: false ,title:this.$t('tool.data')},
							magicType: { show: true, type: ["line", "bar"],title:{
								line:this.$t('tool.line'),
								bar:this.$t('tool.bar')
							} },
							restore: { show: true ,title:this.$t('tool.restore')},
							saveAsImage: { show: true,title:this.$t('tool.down_img') }
						}
					},
					xAxis: [
						{
							type: 'category',
							data: this.month_total_cloud,
							axisTick: {
								alignWithLabel: true
							}
						}
					],
					yAxis: [
						{
							type: 'value'
						}
					],
					series: [
						{
							name: 'Direct',
							type: 'bar',
							barWidth: '60%',
							data: this.month_total,
							label: {
								show: true,
								position: 'top'
							},
							itemStyle: {
								color: function(params) {
									const colors = [
										'#00c2b3', // 蓝绿色（主色）
										'#36a3f7', // 清新蓝
										'#ffb64d', // 明亮橙黄
										'#f2637b', // 西瓜红
										'#91cc75', // 柔和绿
										'#fa8c16', // 活力橙
										'#ab6cf4', // 紫罗兰
										'#3ba272', // 青绿色
										'#fadb14', // 柠檬黄
										'#ff6f00'  // 深橘色
									];
									return colors[params.dataIndex % colors.length];
								}
							}
						}
					]
				};


				option && myChart3.setOption(option);
			},

			//柱状图2
			drawLine4() {
				let myChart4 = echarts.init(this.$refs.myChart4);
				var option;

				option = {
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow'
						}
					},
					grid: {
						left: '3%',
						right: '4%',
						bottom: '3%',
						containLabel: true
					},
					toolbox: {
						feature: {
							dataView: { show: true, readOnly: false ,title:this.$t('tool.data')},
							magicType: { show: true, type: ["line", "bar"],title:{
								line:this.$t('tool.line'),
								bar:this.$t('tool.bar')
							} },
							restore: { show: true ,title:this.$t('tool.restore')},
							saveAsImage: { show: true,title:this.$t('tool.down_img') }
						}
					},
					xAxis: [
						{
							type: 'category',
							data: this.month_order_cloud,
							axisTick: {
								alignWithLabel: true
							}
						}
					],
					yAxis: [
						{
							type: 'value'
						}
					],
					series: [
						{
							name: 'Direct',
							type: 'bar',
							barWidth: '60%',
							data: this.month_order,
							label: {
								show: true,
								position: 'top'
							},
							itemStyle: {
								color: function(params) {
									const colors = [
										'#00c2b3', // 蓝绿色（主色）
										'#36a3f7', // 清新蓝
										'#ffb64d', // 明亮橙黄
										'#f2637b', // 西瓜红
										'#91cc75', // 柔和绿
										'#fa8c16', // 活力橙
										'#ab6cf4', // 紫罗兰
										'#3ba272', // 青绿色
										'#fadb14', // 柠檬黄
										'#ff6f00'  // 深橘色
									];


									return colors[params.dataIndex % colors.length];
								}
							}
						}
					]
				};


				option && myChart4.setOption(option);
			},

			
		
			startLine(){
				console.log(startLine)
			},
			
			
			
	
			//前往修改页面
			toView(name) {
				for (var i = 0; i < this.layout.navBar.list.length; i++) {
					
					let index = this.layout.navBar.list[i].submenu.findIndex(v => v.pathname == name);
					if(index!=-1){
						this.layout.navBar.active = i;
						// 跳转到當前激活
						this.layout.slideMenuActive = index
						break
					}
				}
				this.$router.push({
					name: name,

				})
			},
			// 打开模态框
			openModel(e, type) {
				// console.log(e)
				this.edit_title = '修改'+e.desc
				// 修改
				this.form = {
					url: e.num,
					type:e.o_type
				}
			
				// 打开dialog
				this.createModel = true
			}
		}
	}
</script>



<style>
	.clearfix{
		border-bottom:none!important;
	}
	
  .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #d3dce6;
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
	vertical-align: middle;
    border-radius: 4px;
    min-height: 36px;
	line-height: 36px;
  }
  .row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
  }
	.index_btn{
		display: flex; align-items: center;justify-content: space-between;
	}
	.index_btn_left{
		background-color: #83d8ae;
		box-shadow: 0 3px 18px -8px #83d8ae;
		width: 45px;
		height: 45px;
		
		border-radius: 5px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	.index_btn_left2{
		background-color: #fc9494;
		box-shadow: 0 3px 18px -8px #fc9494;
	}
	.index_btn_left3{
		background-color: #3b8ff3;
		box-shadow: 0 3px 18px -8px #3b8ff3;
	}
	.index_btn_name{
		font-size: 20px;
	}
	.index_btn_info{
		font-size: 13px;color: #aaa;
	}
	
	.index_btn_ft28{
		font-size: 28px;
	}
	
	
	
	.new_home_p{
		font-size: 15px;
		font-weight: bolder;
		color: #333;
		margin-left: 10px;
	}
	.head_row .el-card__body{
		padding: 15px 10px;
	}
	

	.htr_main{
		display: flex;align-items:center;flex-direction: column;justify-content: center;
	}
	.htr_view{
		display: flex;align-items: center;
		justify-content: space-between;
		
		
		
		
		width: 100%;
	}
	.htr_top{
		border-radius: 5px;
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;
		
	}
	.htr_top_new{
	}
	
	.htr_info{
		font-size: 14px;color: #92c0e9;
		
	}
	.htr_desc{
		color: #fff;font-size: 13px;
		text-align: right;
	}
	.htr_icon{
		width: 45px;height: 45px;color: #fff;
		background-color: #83d8ae;
		box-shadow: 0 3px 18px -8px #83d8ae;
		border-radius: 5px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.htr_icon i{
		font-size: 25px;
	}
	.htr_icon_red{
		background: #fc9494;
		box-shadow: 0 3px 18px -8px #fc9494;
	}
	
	
	
	.testbg{
		padding: 20px;
		height: 100%;
	}
	.home_all{
		color: #fff;
		height: calc(100% - 130px);
		
	}
	
	.testbg .el-card__header{
		padding: 10px 20px;
		font-size: 15px;
	}
	.new_card .el-card__body{
		height: calc(100% - 44px);
	}
	.zj_card .el-card__body{
		height: 100%;
	}
	.h_100{
		height: 100%;
	}
	.h_50{
		height: 50%;
	}
	.h_l{
		height: auto;
	}
	.h_r{
		height: auto;
	}
	
	
	.home_all_phone .h_l,.home_all_phone .h_r{
		height: auto;
	}
	/* 新选项數据 */
	.new_head_nav{
		display: flex;align-items: center;
	}
	
	.new_head_nav_icon{
		width: 45px;
		height: 45px;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 50%;
		color: #fff;
		
	}
	
	.new_head_nav_icon i{
		font-size: 25px;
	}
	
	.new_info_div{
		display: flex;
		width: 100%;
		justify-content: space-between;
	}
	.new_head_right{
		flex: 1;
	}
	.new_info{
		color: grey;
		font-size: 13px;
	}
	
	.new_head_num{
		color: #222;
		font-size: 25px;
		margin: px 0;
	}
	
	
	/* 新选项數据 */
	
</style>
